import { authApi } from "shared/api/authApi";

export const forgotPasswordRequest = (payload) => {
  return authApi.forgotPassword(payload);
};
